(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JslibHtml5CameraPhoto", [], factory);
	else if(typeof exports === 'object')
		exports["JslibHtml5CameraPhoto"] = factory();
	else
		root["JslibHtml5CameraPhoto"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition